import { Router } from "express";

import { quizController } from "../controllers/quiz-controller";
import {
  authenticate,
  requireEmailVerification,
} from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import { uploadMiddleware } from "../middleware/upload-middleware";
import { submitQuizValidation } from "../validation/quiz-validation";

const router = Router();

router.use(authenticate);
router.use(requireEmailVerification);
router.use(requireRole(["student"]));

/**
 * @route   GET /api/v1/student/quizzes
 * @desc    Get all available quizzes for student's classes
 * @access  Private (Student)
 * @query   classId
 */
router.get("/", (req, res) => quizController.getStudentQuizzes(req, res));

/**
 * @route   GET /api/v1/student/quizzes/:id
 * @desc    Get quiz details (without answers)
 * @access  Private (Student)
 */
router.get("/:id", (req, res) => quizController.getStudentQuizById(req, res));

/**
 * @route   POST /api/v1/student/quizzes/:id/start
 * @desc    Start a new quiz attempt
 * @access  Private (Student)
 */
router.post("/:id/start", (req, res) =>
  quizController.startQuizAttempt(req, res),
);

/**
 * @route   POST /api/v1/student/quizzes/:id/submit
 * @desc    Submit quiz attempt with answers (and optional file uploads)
 * @access  Private (Student)
 */
router.post(
  "/:id/submit",
  uploadMiddleware.array("files", 10),
  async (req, res) => {
    let answers = req.body.answers;
    if (typeof answers === "string") {
      try {
        answers = JSON.parse(answers);
        req.body.answers = answers;
      } catch {
        return res.status(400).json({
          success: false,
          message: "Invalid answers format",
          error: "Answers must be valid JSON array",
        });
      }
    }

    const { error } = submitQuizValidation.validate(req.body);
    if (error) {
      return res.status(400).json({
        success: false,
        message: "Validation failed",
        error: error.details[0].message,
      });
    }
    return quizController.submitQuizAttempt(req, res);
  },
);

/**
 * @route   GET /api/v1/student/quizzes/:id/results
 * @desc    Get quiz results and all attempts
 * @access  Private (Student)
 */
router.get("/:id/results", (req, res) =>
  quizController.getQuizResults(req, res),
);

export default router;
